import { ON_LOGOUT } from 'app/actions/authActions';
import { createReducer } from 'utils/appHelpers';

const ON_PROJECT_ITEMS_SET = '@@home/ON_PROJECT_ITEMS_SET';
const ON_REMOVE_ONE_PROJECT_ITEM = '@@home/ON_REMOVE_ONE_PROJECT_ITEM';

const initialData = {};

const projectItemsRelHandlers = {
  [ON_PROJECT_ITEMS_SET]: (state, action) => {
    return { ...state, [action.payload.projectID]: action.payload.body };
  },
  [ON_REMOVE_ONE_PROJECT_ITEM]: (state, action) => {
    const newState = { ...state };
    Object.keys(newState).forEach(key => {
      newState[key].items = newState[key].items.filter(item => item.id !== action.payload);
    });
    return { ...newState };
  },
  [ON_LOGOUT]: () => initialData,
};

export const onSetProjectItems = payload => ({ type: ON_PROJECT_ITEMS_SET, payload });
export const onRemoveProjectItemsItem = payload => ({ type: ON_REMOVE_ONE_PROJECT_ITEM, payload });

export const projectItemsRelationsReducer = createReducer(initialData, projectItemsRelHandlers);
